module.exports = __webpack_public_path__ + "static/media/demo2.1fb91089.png";